import { StoreState } from '../../Store';
import { connect } from 'react-redux';
import PageLayout from '../Pages/PageLayout';
import { PageLayoutProps } from '../Pages/PageLayoutProps';

function mapStateToProps(state: StoreState, props: PageLayoutProps): PageLayoutProps {
  return {
    ...props,
    isNextGenUi: true,
  };
}
export default connect(mapStateToProps)(PageLayout);
